import { render } from "./TestimonialPopupList.vue?vue&type=template&id=33d4003e&ts=true"
import script from "./TestimonialPopupList.vue?vue&type=script&lang=ts"
export * from "./TestimonialPopupList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__